export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.routes) {
        return {...state, ...payload.routes};
      }
      return state;
    }
  }
};
